'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var GenresNavController = (function () {
    function GenresNavController($scope, BPGenresService) {
        _classCallCheck(this, GenresNavController);

        this.BPGenresService = BPGenresService;
        this.$scope = $scope;

        this.initGenres();
    }

    _createClass(GenresNavController, [{
        key: 'initGenres',
        value: function initGenres() {
            var _this = this;

            this.BPGenresService.getGenres().then(function (genres) {
                _this.$scope.genres = genres;
            });
        }
    }]);

    return GenresNavController;
})();

exports['default'] = GenresNavController;

GenresNavController.$inject = ['$scope', 'BPGenresService'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/markup/genres_nav_controller.js
 ** module id = 39
 ** module chunks = 0
 **/